import Features, {languageCodeInUrl} from "@atg-shared/client-features";
import {getLanguage} from "./getLanguage";
import {getLanguages} from "./getLanguages";

export function getLanguageBasename() {
    // language basename will only be included for markets that support more than one locale
    const shouldIncludeLanguageBasename = getLanguages().length > 1;

    if (!Features.isEnabled(languageCodeInUrl) || !shouldIncludeLanguageBasename) {
        return "";
    }

    const {lang} = getLanguage();

    return `/${lang}`;
}
